import { css } from '@emotion/core'
import { colors } from '@fs/zion-ui'

export const droppableContainerCss = css`
  border-radius: 4px;
`

export const activeBorderCss = css`
  ${droppableContainerCss};
  outline: solid 4px ${colors.blue10};
  outline-offset: 4px;
`
